<script setup>
import { useModyApi } from "~/middelware/ModyApi";
import {useUserDataStorage} from "~/store/userdata";
const router = useRouter()

useSeoMeta({
  title: "Account",
  ogTitle: "Account"
})
const email = ref("stefan.schaefer998@gmail.com");
const password = ref("");

const userDataStore = useUserDataStorage();
const { user } = storeToRefs(userDataStore)
const showErrorModal = ref(false)

async function login() {
  try {
    user.value = await useModyApi().login(email.value, password.value);
    user.value.role = await useModyApi().getUserRole()
    password.value = ""
    await router.replace('/admin')
  }
  catch (e) {
    showErrorModal.value = true
    password.value = ""
  }
}
async function logout() {
  user.value = new User();
}
</script>

<template>
  <div>
    <div v-if="!userDataStore.loggedIn">
      <form @submit.prevent="login" class="login-form">
        <NuxtImg src="/rgb_negativ.png" alt="Mody Logo" class="w-[200px] m-auto mb-4"/>
        <InputGroup>
          <InputGroupAddon>
            <i class="pi pi-user"></i>
          </InputGroupAddon>
          <InputText id="email"  placeholder="email" autocomplete="username" v-model="email"  />
        </InputGroup>
        <InputGroup>
          <InputGroupAddon>
            <i class="pi pi-lock"></i>
          </InputGroupAddon>
          <InputText id="password" type="password" placeholder="password" autocomplete="current-password" v-model="password"  />
        </InputGroup>

        <Button type="submit">Login</Button>
      </form>
    </div>
    <div v-else>
      <Card class="user-container">
        <template #header>
          <i class="pi pi-user"></i>
        </template>
        <template #title>
          <div>Hallo {{user.username}}!</div>
        </template>
        <template #content>
          <InputText v-model="user.email" disabled class="mb-3"/>
          <NuxtLink to="/myEvents">
            <Button outlined class="w-100">Meine Events</Button>
          </NuxtLink>
        </template>
        <template #footer>
          <Button @click="logout">logout</Button>
        </template>
      </Card>
    </div>
    <Dialog v-model:visible="showErrorModal" modal header="Fehler" @hide="password = ''">
      <p>
        Bei der Anmeldung ist etwas schief gelaufen.
      </p>
    </Dialog>
  </div>
</template>
<style scoped lang="scss">

.login-form{
  padding:20px;
  margin-top:50%;
  margin-bottom:50%;
  text-align: center;
  @include desktop(){
    width:calc($desktop-content-width - 100px);
    margin:auto auto 100px auto;
  }
  :deep(.p-image){
    display:block;
    margin-bottom: 20px;
  }
  .p-inputgroup{
    margin-bottom: 20px;
  }
  .p-button{
    width:100%;
    display:block;
  }
}
.user-container{
  margin:20px;
  background:none;
  @include desktop(){
    width:calc($desktop-content-width - 100px);
    margin:auto auto 100px auto;
  }
  :deep(.p-card-header){
    text-align: center;
    padding: 1.5rem;
    .pi{
      background:$myOrange;
      padding: 30px;
      border-radius: 50%;
      color:$myGrey;
      font-size: 3rem;
    }
  }
  :deep(.p-card-content){
    .p-inputtext{
      width:100%;
    }
  }
  :deep(.p-card-footer){
    .p-button{
      width:100%;
      display:block;
    }
  }
}

</style>
